var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashValueIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 60,
    viewBox: "0 0 84 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 60,
    rx: 29.4545,
    fill: "#AFA07B",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7153_14848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.0215 25.1665C45.0215 26.1694 45.8311 26.979 46.834 26.979C47.8369 26.979 48.6465 26.1694 48.6465 25.1665C48.6465 24.1636 47.8369 23.354 46.834 23.354C45.8311 23.354 45.0215 22.5444 45.0215 21.5415C45.0215 20.5386 45.8311 19.729 46.834 19.729C47.8369 19.729 48.6465 20.5386 48.6465 21.5415",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.834 26.979V28.7915",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.834 17.9165V19.729",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0625 22.75V23.9583",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6045 22.75V23.9583",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3545 33.021V34.2293",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2503 35.4375C45.1239 30.9546 38.9795 33.0208 38.9795 33.0208",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8955 33.021C55.8955 35.0268 54.2763 36.646 52.2705 36.646",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1878 29.4984C39.5112 29.5709 38.8526 29.6857 38.2122 29.8367L38.1397 29.7642C36.7199 28.3444 34.9074 27.3778 32.9378 26.979L33.9589 31.5646C32.7687 32.3138 31.8201 33.22 31.228 34.229H28.1045L28.7087 39.0623H31.3187C32.0497 40.0834 33.246 40.893 34.7503 41.485L34.1462 43.8957H38.3753V42.4215C39.5293 42.5967 40.7557 42.6873 42.0003 42.6873C43.2449 42.6873 44.4895 42.5907 45.6253 42.4094V43.8957H49.8545L49.2503 41.3703C51.4676 40.3673 52.8753 38.7905 52.8753 36.6457C52.8753 34.7003 51.7274 32.9361 49.8545 31.6311",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.833 30.604C50.8371 30.604 54.083 27.3581 54.083 23.354C54.083 19.3499 50.8371 16.104 46.833 16.104C42.8289 16.104 39.583 19.3499 39.583 23.354C39.583 27.3581 42.8289 30.604 46.833 30.604Z",
    stroke: "#0D4248",
    strokeWidth: 1.38095,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7153_14848"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    fill: "white",
    transform: "translate(27.5 15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashValueIcon);
export default __webpack_public_path__ + "static/media/cash-value-icon.93f40f97f01dc3449d4fdadc675b6553.svg";
export { ForwardRef as ReactComponent };